import { render, staticRenderFns } from "./degree.vue?vue&type=template&id=29553e82&scoped=true&"
import script from "./degree.vue?vue&type=script&lang=js&"
export * from "./degree.vue?vue&type=script&lang=js&"
import style0 from "./degree.vue?vue&type=style&index=0&id=29553e82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29553e82",
  null
  
)

export default component.exports